import Wrapper from "components/LayoutFront/Wrapper";
import PropTypes from "prop-types";
import React from "react";

const Decrees = (props) => {
  const { decreesTitle, decrees = null } = props;

  return (
    <Wrapper sx={{ px: { xs: 2, lg: 0 } }}>
      <h2>{decreesTitle}</h2>
      {decrees}
    </Wrapper>
  );
};

Decrees.propTypes = {
  decreesTitle: PropTypes.node,
  decrees: PropTypes.node,
};

export default Decrees;
